import AttendeeListItem from './AttendeeListItem';
import type { Attendee } from '@blocksServices/apollo/types';

interface AttendeesListProps {
	attendees: Array<Attendee>;
	avatarSize?: number;
	showGravatar?: boolean;
	containerClassName?: string;
	containerId?: string;
}

const AttendeesList: React.FC<AttendeesListProps> = ({
	attendees,
	avatarSize,
	containerClassName,
	containerId,
	showGravatar,
}) => {
	let fontSize = avatarSize ?? 24;
	let fontSizeClass = '';
	// avatar size ranges from 10 to 128, so we need to scale it down to a more manageable number
	fontSize = Math.ceil(fontSize / 10);
	fontSize = Math.max(1, fontSize);
	// we should now have a range between 1 and 13
	if (fontSize < 2) {
		fontSizeClass = 'font-size-xxs';
	} else if (fontSize < 4) {
		fontSizeClass = 'font-size-xs';
	} else if (fontSize < 6) {
		fontSizeClass = 'font-size-sm';
	} else if (fontSize < 8) {
		fontSizeClass = 'font-size-md';
	} else if (fontSize < 10) {
		fontSizeClass = 'font-size-lg';
	} else if (fontSize < 12) {
		fontSizeClass = 'font-size-xl';
	} else {
		fontSizeClass = 'font-size-xxl';
	}

	return (
		<div id={containerId} className={containerClassName + ' event-attendees ' + fontSizeClass}>
			<ul>
				{attendees.map((attendee) => {
					return (
						<AttendeeListItem
							attendee={attendee}
							avatarSize={avatarSize}
							key={attendee.id}
							showGravatar={showGravatar}
						/>
					);
				})}
			</ul>
		</div>
	);
};

export default AttendeesList;
